import React from 'react';
import { X } from 'lucide-react';

// Timeline Event Detail Modal
export const TimelineDetailModal = ({
  isOpen,
  onClose,
  selectedTimelineEvent
}) => {
  if (!isOpen || !selectedTimelineEvent) return null;

  const eventTitles = {
    invoice_created: "Invoice was created",
    contact_updated: "Contact was updated",
    due_date_updated: "Due date was updated",
    payment_captured: "Payment was captured",
    payment_updated: "Payment was updated",
    payment_deleted: "Payment was deleted",
    credit_note_added: "Credit note was added",
    credit_note_updated: "Credit note was updated",
    credit_note_deleted: "Credit note was deleted",
    note_added: "Note was added",
    expenses_attached: "Expenses were attached",
    invoice_updated: "Invoice was updated"
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[60]">
      <div className="bg-white rounded-xl max-w-2xl w-full m-4 shadow-2xl">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <h3 className="text-xl font-semibold text-gray-900">
            {eventTitles[selectedTimelineEvent.type] || "Invoice was updated"}
          </h3>
          <button
            onClick={handleClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X size={24} />
          </button>
        </div>

        {/* Content */}
        <div className="p-6">
          {/* Timestamp and User */}
          <div className="grid grid-cols-2 gap-4 mb-6">
            <div>
              <p className="text-sm text-gray-600 mb-1">On</p>
              <p className="text-gray-900 font-medium">
                {new Date(selectedTimelineEvent.timestamp).toLocaleString('en-US', {
                  month: 'long',
                  day: 'numeric',
                  year: 'numeric',
                  hour: 'numeric',
                  minute: '2-digit',
                  second: '2-digit',
                  hour12: true
                })}
              </p>
            </div>
            <div>
              <p className="text-sm text-gray-600 mb-1">By</p>
              <p className="text-gray-900 font-medium">{selectedTimelineEvent.by}</p>
            </div>
          </div>

          {/* Changes Section */}
          {selectedTimelineEvent.changes && Object.keys(selectedTimelineEvent.changes).length > 0 && (
            <>
              <div className="border-t border-b border-gray-200 py-3 mb-4">
                <h4 className="text-center text-gray-700 font-semibold">CHANGES</h4>
              </div>

              {/* Changes Table */}
              <div className="overflow-hidden">
                <table className="w-full">
                  <thead>
                    <tr className="border-b-2 border-gray-200">
                      <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">Property</th>
                      <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">Old Value</th>
                      <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">New Value</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Object.entries(selectedTimelineEvent.changes).map(([property, values]) => (
                      <tr key={property} className="border-b border-gray-100">
                        <td className="py-3 px-4 text-sm text-gray-900 font-medium">{property}</td>
                        <td className="py-3 px-4 text-sm text-gray-600">{values.old || "-"}</td>
                        <td className="py-3 px-4 text-sm text-gray-900 font-medium">{values.new || "-"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default TimelineDetailModal;
